import { BaseEntity } from 'src/app/core/domain/base.entity';
import { SimNao } from '../simNao/sim-nao';

export class AcaoOrcamentaria extends BaseEntity {
  descricao: string;
  controlaCc: SimNao;
}
